import React from "react"

const TaskAnswerEditorContext = React.createContext(null)

export default TaskAnswerEditorContext
